// extracted by mini-css-extract-plugin
module.exports = {"main":"InfoWithImageSection_main__vDhbN","btn":"InfoWithImageSection_btn__dEHFK"};